"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MenuBlockModule = _interopRequireDefault(require("./MenuBlock.module.scss"));

var _BorderedBox = _interopRequireDefault(require("../../common/BorderedBox/BorderedBox"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function modifyChild(child, index) {
  var modifiedClassName = (0, _classnames.default)(child.className, _MenuBlockModule.default.entry, _MenuBlockModule.default["entry".concat(index % 5 + 1)]); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  return /*#__PURE__*/_react.default.cloneElement(child, {
    className: modifiedClassName
  });
}

var MenuBlock = function MenuBlock(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "red" : _ref$color,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MenuBlockModule.default.block, _MenuBlockModule.default[color], className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_BorderedBox.default, {
    className: _MenuBlockModule.default.box
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MenuBlockModule.default.title, _MenuBlockModule.default[color])
  }, title), _react.default.Children.map(children, function (child, index) {
    return modifyChild(child, index);
  })));
};

var _default = MenuBlock;
exports.default = _default;